module.exports = __webpack_public_path__ + "static/img/7-1.6ee2b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/7-1.png
// module id = 1qoA
// module chunks = 25